module.exports = __webpack_public_path__ + "resources/img/img_dsm1.5f18e1ef35bc85fe760c0db375dd6fa8.png";